import { type Hash } from 'history';
import { matchPath } from 'react-router';

const parseEmailFromSearch = (search: string | undefined) => {
  if (!search) return undefined;
  const match = search.match(/(?:^|[?&])email=([^&]*)/);
  if (!match?.[1]) return undefined;
  try {
    // Do not use URLSearchParams it will decode the '+' to a space.
    return decodeURIComponent(match[1]);
  } catch {
    return undefined;
  }
};

const changePasswordMatcher = (hash: Hash) => {
  const path = hash.substring(1);
  const [pathname, search] = path.split('?');
  const match = matchPath('/change-password/:userId/:token', pathname);
  if (!match) return null;
  return {
    ...match.params,
    email: parseEmailFromSearch(search),
  };
};

export default changePasswordMatcher;
